import { Material } from './Material';
import { Transform } from './Transform';
export class GameObject {
    constructor() {
        this.id = Object.toString();
        this.text = [];
        this.transform = new Transform();
        this.material = new Material();
        this.name = '';
    }
    start() { }
    // @ts-ignore
    update(elapsedTime) { }
    // @ts-ignore
    onCollisionEnter(col) { }
    // @ts-ignore
    onCollisionExit(col) { }
}
//# sourceMappingURL=GameObject.js.map